import { motion } from "framer-motion";

const easing = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.8, ease: easing, delay }}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal. `lines` is an array of strings or nodes.
// mount=true animates immediately (for above-the-fold hero); otherwise on scroll into view.
export const MaskText = ({ lines, className = "", lineClass = "", start = 0, stagger = 0.09, mount = false }) => {
  const anim = mount
    ? { animate: { y: "0%" } }
    : { whileInView: { y: "0%" }, viewport: { once: true } };
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="mask-line">
          <motion.span
            className={`block ${lineClass}`}
            initial={{ y: "110%" }}
            {...anim}
            transition={{ duration: 0.9, ease: easing, delay: start + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};
